import { Stack } from "@mui/material";
import TableConstructor from "layout/TableConstructor";
import { useNavigate } from "react-router-dom";
import {
  OrderType,
  PlatformVacancyListOrderFields,
  PlatformVacancyListOrderInput,
  useVacanciesListQuery,
} from "@generated/graphql";
import { RouteEnum } from "layout/TableConstructor/types";
import Header from "./components/Header";
import filterConfig from "./tableConfig/filterConfig";
import columnConfig from "./tableConfig/columnConfig";
import { VacanciesFilter, VacancyItem } from "./types";

const VacanciesList = () => {
  const navigate = useNavigate();

  const order: PlatformVacancyListOrderInput = {
    field: PlatformVacancyListOrderFields.CreatedAt,
    order: OrderType.Desc,
  };
  const { data, loading, refetch } = useVacanciesListQuery({
    variables: {
      page: 0,
      limit: 50,
      filter: {},
      order,
    },
  });

  const vacanciesList = data?.vacancies.data || [];
  const totalCount = data?.vacancies.totalCount;

  return (
    <Stack>
      <Header />
      <TableConstructor<VacancyItem, VacanciesFilter, PlatformVacancyListOrderFields, undefined>
        exportRoute={RouteEnum.Vacancy}
        settingsModalTitle='Список вакансий'
        data={vacanciesList}
        totalCount={totalCount}
        loading={loading}
        columnsConfig={columnConfig}
        filtersConfig={filterConfig}
        emptyPlaceholderText='Пока нет вакансий'
        refetch={refetch}
        storageName='vacanciesList'
        onRowClick={(row) => navigate(`view/${row.id}`)}
        defaultOrder={order}
        defaultVisibleColumnList={["numericId", "title", "createdAt", "companyCandidatesCount"]}
      />
    </Stack>
  );
};

export default VacanciesList;
